module.exports = __webpack_public_path__ + "static/media/report.04a40a03.svg";